import React, { useState } from "react";
import Modal from "components/Models/index";
import Input from "components/Input/index";

const NewFileModal = ({ show, onClose, onCreate, fileType }) => {
  const [fileName, setFileName] = useState("");
  const [error, setError] = useState("");

  const handleCreate = async () => {
    if (!fileName.trim()) {
      setError("File name is required");
      return;
    }
    setError("");
    await onCreate(fileName.trim(), fileType);
    setFileName("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleCreate();
    }
  };

  if (!show) return null;

  return (
    <Modal
      isVisible={show}
      handleSave={handleCreate}
      handleCancel={onClose}
      heading={`Create New ${fileType === "doc" ? "Document" : "Sheet"}`}
      submitBtnText="Create"
      width="30%"
      isDisabled={!fileName.trim()}
      showCross={true}
      showHeader={true}
    >
      <div style={{ padding: "10px 20px 30px 20px" }}>
        <Input
          width="100%"
          placeholder="Enter file name"
          value={fileName}
          onChange={(e) => {
            // Keep consistency with folder naming logic
            const newValue = e.target.value.replace(
              /[^a-zA-Z0-9 _\-()]/g,
              ""
            );
            setFileName(newValue);
          }}
          autoFocus={true}
          onKeyDown={handleKeyDown}
          label="File Name"
          maxLength={80}
        />
        {error && <p style={{ color: "red", fontSize: "12px", marginTop: "5px", paddingLeft: "5px" }}>{error}</p>}
      </div>
    </Modal>
  );
};

export default NewFileModal;
